import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../component/base/header-component/HeaderComponent';
import FooterComponent from '../../component/base/footer-component/FooterComponent';
import OnboardButton from '../../component/base/onboard-button-component/OnboardButton';
import OnboardTablePartner from '../../component/base/onboard-table-partner-component/OnboardTablePartner';
import parse from 'html-react-parser';
import CacheManager from '../../util/CacheManager';
import Const from '../../constant/Const';
import { getAllFreeWifiPackages } from '../../example/getAllFreeWifiPackages';
import { setSimulationNumber } from '../../util/SimulationManager';

const FreeInternetRightsPage = (props) => {
    const { t, i18n, navigate, setLoading, handleInformation } = props.props;
    const simulationNumber = setSimulationNumber();

    const [empty, setEmpty] = useState(false);
    const [body, setBody] = useState([]);
    const [sortList, setSortList] = useState([]);
    const tableHeader = [t('package_definition'), t('quota')];

    const cacheManager = new CacheManager(Const.FREE_INTERNET_RIGHTS);

    useEffect(() => {
        handleInformation('free_internet_rights');
        simulationNumber(3, 1);

        if (useCache()) return;
        setLoading(true);

        let result = getAllFreeWifiPackages;
        setLoading(false);
        if (result.data != null) {
            setEmpty(false);
            const sortList = result.data?.sort((a, b) => a.freePackageStatus?.localeCompare(b.freePackageStatus));
            setSortList(sortList);
            cacheManager.setCache(sortList);
            setupPackageList(sortList);
        } else
            setEmpty(true);

    }, []);

    useEffect(() => {
        setupPackageList(sortList);
    }, [i18n.language]);

    const useCache = () => {
        let cacheData = cacheManager.getCache();
        if (cacheData !== null) {
            setEmpty(false);
            setSortList(cacheData);
            setupPackageList(cacheData);
            return true;
        }
        return false;
    };

    const setupPackageList = (sortList) => {
        if (sortList.length > 0) {
            let list = [];
            let isTrLang = /tr/.test(i18n.language.toLowerCase());
            sortList.forEach(value => {
                let cabinClass = value.freePackageStatus === 'FREE_BUSINESS' ? t('class.business') : t('class.economy');
                list.push({
                    text: cabinClass,
                    sub: (isTrLang ? value.description_tr : value.description_en),
                    result: (isTrLang ? value.name_tr : value.name_en)
                });
            });
            setBody(list);
        }
    };

    return (
        <div className="full-height-screen">
            <HeaderComponent title={t('free_internet_rights.title')} content={t('free_internet_rights.content')}
                             informationSet={4}
                             informationSetStep={1}
                             showBack />

            <div className="content-root top">

                {body.length !== 0 && <OnboardTablePartner header={tableHeader} body={body} />}

                {body.length === 0 &&
                    <p className="text-center m-t-150 m-b-170">{parse(empty ? t('purchase_package.error.service') : t('please_wait'))}</p>}

                <div className="h-42" />

                <OnboardButton label={t('login.sign_up_miles_smiles')}
                               onClick={() => navigate('/miles-and-smiles-register', { state: 'login' })} />

            </div>

            <FooterComponent />

        </div>
    );
};

export default FreeInternetRightsPage;

